import { registerDestructor } from "@ember/destroyable";
import Modifier from "ember-modifier";
import { bind } from "discourse/lib/decorators";
export default class FloatKitCloseOnEscape extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    registerDestructor(this, instance => instance.cleanup());
  }
  modify(element, [closeFn]) {
    this.closeFn = closeFn;
    this.element = element;
    document.addEventListener("keydown", this.check, {
      capture: true
    });
  }
  check(event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      event.preventDefault();
      this.closeFn();
    }
  }
  static {
    dt7948.n(this.prototype, "check", [bind]);
  }
  cleanup() {
    document.removeEventListener("keydown", this.check, {
      capture: true
    });
  }
}